const euCountryCodes = {
  AT: 'Austria',
  BE: 'Belgium',
  BG: 'Bulgaria',
  CY: 'Cyprus',
  HR: 'Croatia',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  EE: 'Estonia',
  FI: 'Finland',
  FR: 'France',
  DE: 'Germany',
  GR: 'Greece',
  EL: 'Greece',
  IE: 'Ireland',
  HU: 'Hungary',
  IT: 'Italy',
  LV: 'Latvia',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MT: 'Malta',
  NL: 'Netherlands',
  PL: 'Poland',
  PT: 'Portugal',
  RO: 'Romania',
  SK: 'Slovakia',
  SI: 'Slovenia',
  ES: 'Spain',
  SE: 'Sweden',
  GB: 'United Kingdom',
  UK: 'United Kingdom',
};

/**
 * Check if the input country is EU (excluding GB & UK)
 * @param {string} countryCode - The country code to check
 * @return {boolean} True if country is EU (excluding GB & UK), false otherwise
 */
export const isEuCountry = (countryCode: string): boolean => {
  if (!countryCode) return false;
  const upperCode = countryCode.toUpperCase();
  // Exclude GB & UK from the EU codes
  if (upperCode === 'GB' || upperCode === 'UK') {
    return false;
  }
  return upperCode in euCountryCodes;
};
